/** Id of the primary nav's Servers link, where focus goes when the focused tree row disappears. */
export const SHELL_SERVERS_LINK_ID = 'shell-nav-servers';

/**
 * "Skip to content": hidden until focused, then drawn on graphite at the top left. `not-sr-only` resets padding, so
 * the padding is set again under `focus:`.
 */
export const skipLinkClasses =
  'chrome focus-ring sr-only z-50 rounded-sm border border-chrome-border-strong text-sm font-medium focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:px-3 focus:py-2';

/** Primary nav link on the graphite shell. `data-section` brightens the text without marking the link current. */
export const navItemClasses =
  'focus-ring flex h-8 items-center gap-2 rounded-sm px-2 text-sm font-medium text-chrome-muted transition-colors hover:bg-chrome-2 hover:text-chrome-text data-[section]:text-chrome-text aria-[current=page]:bg-chrome-3 aria-[current=page]:text-chrome-text lg:h-7.5 [&_svg]:size-4 [&_svg]:shrink-0';

/** "Pair a server": an outlined link on the graphite shell. */
export const pairItemClasses =
  'focus-ring flex h-8 items-center gap-1.5 rounded-sm border border-chrome-border-strong px-2 text-sm font-medium text-chrome-text transition-colors hover:bg-chrome-2 aria-[current=page]:bg-chrome-3 lg:h-7.5 [&_svg]:size-4 [&_svg]:shrink-0';

/** Theme and account menu triggers on the graphite shell. */
export const iconButtonClasses =
  'focus-ring inline-flex size-8 shrink-0 items-center justify-center rounded-sm text-chrome-muted transition-colors hover:bg-chrome-2 hover:text-chrome-text data-[state=open]:bg-chrome-3 data-[state=open]:text-chrome-text [&_svg]:size-4';

/** Expand toggle of a server row. The tree scrolls, so focus outlines are drawn inside. */
export const treeToggleClasses =
  'focus-ring inline-flex size-6 shrink-0 items-center justify-center rounded-sm text-chrome-muted transition-colors hover:bg-chrome-2 hover:text-chrome-text focus-visible:-outline-offset-2 [&_svg]:size-4';

/**
 * Tree link. `data-ancestor` marks a link that contains the current page. In forced colors the current link is filled
 * with `Highlight` by the unlayered rule in `index.css`; its inset focus outline is set to `HighlightText` with
 * `!important`, which outranks that rule.
 */
export const treeItemClasses =
  'focus-ring flex min-h-7 min-w-0 flex-1 items-center gap-2 rounded-sm px-2 py-1 text-sm text-chrome-muted transition-colors hover:bg-chrome-2 hover:text-chrome-text focus-visible:-outline-offset-2 data-[ancestor]:font-medium data-[ancestor]:text-chrome-text aria-[current=page]:bg-chrome-3 aria-[current=page]:font-medium aria-[current=page]:text-chrome-text forced-colors:aria-[current=page]:outline-[color:HighlightText]!';

/** Short note in the tree, such as an empty or offline state. */
export const treeNoteClasses = 'px-2 py-1 text-xs text-chrome-muted';

/** Retry button in the tree. Its label starts on the left edge of the note text above it. */
export const treeRetryClasses =
  'focus-ring mx-1 inline-flex h-6 items-center rounded-sm px-1 text-xs font-medium text-chrome-text underline underline-offset-3 hover:bg-chrome-2 focus-visible:-outline-offset-2';
